<template>
  <b-container fluid>
    <backlink />
    <h1>Produits spéciaux</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="type" slot-scope="{ data }">
        {{ $store.getters["product/getType"](data.value) ? $store.getters["product/getType"](data.value).text : data.value }}
      </template>
      <!--
        La colonne reste vide pour une location pour compte : elle n'est pas un produit
        parent, elle figure ici au titre de sa nature d'offre. Le getter rend `undefined`
        pour une valeur nulle — sans garde, le rendu de toute la table s'interrompt.
      -->
      <template slot="parent_product_type" slot-scope="{ data }">
        {{ $store.getters["product/getParentType"](data.value) ? $store.getters["product/getParentType"](data.value).text : "" }}
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config-parent.js";

export default {
  name: "ParentProductList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
      product_id: null,
      movement_quantity: null,
      movement_purchase_price: null,
      movement_order_number: null,
      movement_type: "product-add-stock",
    };
  },
  computed: {
    options: function () {
      let status_options = this.$store.getters["status/getByGroup"]("product")
        .selectOptions("status_slug", "name")
        .filter(
          (item) => item.value != "product-add-stock" && item.value != "product-remove-stock"
        )
      return {
        status_options: [
          status_options[1],
          status_options[0],
        ],
        type_options: this.$store.getters["product/getTypes"],
        equipment_group_options: this.$store.getters["equipment_group/getAllForSelect"],
        parent_product_type_options: this.$store.getters['product/getParentTypesForSelect']
      };
    },
  },
  mounted() {
    this.$store.dispatch("equipment_group/getAll");
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;

      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "product", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              statusSlug: ctx.extended_filters_model.status,
              type: ctx.extended_filters_model.type,
              equipment_group: ctx.extended_filters_model.equipment_group,
              parents: true,
              parent_product_type: ctx.extended_filters_model.parent_product_type,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.products || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
    addMovement() {
      if (this.product_id && this.movement_quantity) {
        this.$store
          .dispatch("product_log/addItem", {
            quantity: this.movement_quantity,
            status_slug: this.movement_type,
            product_id: this.product_id,
            purchase_price:
              this.movement_type == "product-add-stock" ? this.movement_purchase_price : null,
            order_number:
              this.movement_type == "product-add-stock" ? this.movement_order_number : null,
          })
          .then((response) => {
            this.$store
              .dispatch(this.config.storeNamespace + "/getItem", {
                id: this.product_id,
              })
              .then(() => {
                this.$root.$emit("bv::hide::modal", "modal-stock-movement");
                this.movement_quantity = null;
                this.movement_purchase_price = null;
                this.movement_order_number = null;
                this.movement_type = "product-add-stock";
              });
          })
          .catch((error) => {
            this.$emit("submit:create:error", error);
            this.inSaving = false;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Product/ParentProductList.vue